import BlockSettingsSchema from '@plone/volto/components/manage/Blocks/Block/Schema';
import type { BlockConfigBase, BlocksConfigData } from '@plone/types';
// BANNER
import BannerSVG from '@redturtle/qubicaamf-theme/icons/banner_icon.svg';
import { BannerEdit } from '@redturtle/qubicaamf-theme/components/Blocks/Banner';
import BannerView from '@redturtle/qubicaamf-theme/components/Blocks/Banner/View';
import BannerSchema from '@redturtle/qubicaamf-theme/components/Blocks/Banner/schema';
import { type BannerConfig } from '@redturtle/qubicaamf-theme/components/Blocks/Banner/schema';

// VIDEO BANNER
import VideoBannerSVG from '@redturtle/qubicaamf-theme/icons/video-banner.svg';
import { VideoBannerEdit } from '@redturtle/qubicaamf-theme/components/Blocks/VideoBanner';
import VideoBannerView from '@redturtle/qubicaamf-theme/components/Blocks/VideoBanner/View';
import VideoBannerSchema from '@redturtle/qubicaamf-theme/components/Blocks/VideoBanner/schema';
import { type VideoBannerConfig } from '@redturtle/qubicaamf-theme/components/Blocks/VideoBanner/schema';

// IMAGE GALLERY
import ImageGalleryIcon from '@redturtle/qubicaamf-theme/icons/gallery_icon.svg';
import ImageGalleryEdit from '@redturtle/qubicaamf-theme/components/Blocks/ImageGallery/Edit';
import ImageGalleryView from '@redturtle/qubicaamf-theme/components/Blocks/ImageGallery/View';
import ImageGallerySchema from '@redturtle/qubicaamf-theme/components/Blocks/ImageGallery/schema';
import { type ImageGalleryConfig } from '@redturtle/qubicaamf-theme/components/Blocks/ImageGallery/schema';
// TABS
import TabsIconSVG from '@redturtle/qubicaamf-theme/icons/tabs_icon.svg';
import TabsEdit from '@redturtle/qubicaamf-theme/components/Blocks/Tabs/Edit';
import TabsView from '@redturtle/qubicaamf-theme/components/Blocks/Tabs/View';
import TabsSchema from '@redturtle/qubicaamf-theme/components/Blocks/Tabs/schema';
import { type TabsConfig } from '@redturtle/qubicaamf-theme/components/Blocks/Tabs/schema';
// ACCORDION
import accordionSVG from '@plone/volto/icons/list-arrows.svg';
import { AccordionEdit } from '@redturtle/qubicaamf-theme/components/Blocks/Accordion';
import {
  AccordionSchema,
  type AccordionConfig,
} from '@redturtle/qubicaamf-theme/components/Blocks/Accordion/schema';
import AccordionView from '@redturtle/qubicaamf-theme/components/Blocks/Accordion/View';
// CARD WITH IMAGES
import { CardWithImagesEdit } from '@redturtle/qubicaamf-theme/components/Blocks/CardWithImages';
import {
  CardWithImagesSchema,
  type CardWithImagesConfig,
} from '@redturtle/qubicaamf-theme/components/Blocks/CardWithImages/schema';
import CardWithImagesView from '@redturtle/qubicaamf-theme/components/Blocks/CardWithImages/View';
import CardWithImagesSVG from '@redturtle/qubicaamf-theme/icons/cardwithimages.svg';
// PAGEINTRO
import { PageIntroEdit } from '@redturtle/qubicaamf-theme/components/Blocks/PageIntro';
import {
  PageIntroSchema,
  type PageIntroConfig,
} from '@redturtle/qubicaamf-theme/components/Blocks/PageIntro/schema';
import PageIntroView from '@redturtle/qubicaamf-theme/components/Blocks/PageIntro/View';
import pageintroSVG from '@redturtle/qubicaamf-theme/icons/pageintro.svg';
// CALL TO ACTION
import { CallToActionEdit } from '@redturtle/qubicaamf-theme/components/Blocks/CallToAction';
import {
  CallToActionSchema,
  type CallToActionConfig,
} from '@redturtle/qubicaamf-theme/components/Blocks/CallToAction/schema';
import CallToActionView from '@redturtle/qubicaamf-theme/components/Blocks/CallToAction/View';
import calltoactionSVG from '@redturtle/qubicaamf-theme/icons/calltoaction.svg';
// TESTIMONIALS
import { TestimonialsEdit } from '@redturtle/qubicaamf-theme/components/Blocks/Testimonials';
import {
  TestimonialsSchema,
  type TestimonialsConfig,
} from '@redturtle/qubicaamf-theme/components/Blocks/Testimonials/schema';
import TestimonialsView from '@redturtle/qubicaamf-theme/components/Blocks/Testimonials/View';
// ICONS AND TEXT
import { IconsAndTextEdit } from '@redturtle/qubicaamf-theme/components/Blocks/IconsAndText';
import {
  IconsAndTextSchema,
  type IconsAndTextConfig,
} from '@redturtle/qubicaamf-theme/components/Blocks/IconsAndText/schema';
import IconsAndTextView from '@redturtle/qubicaamf-theme/components/Blocks/IconsAndText/View';
import iconsAndTextSVG from '@redturtle/qubicaamf-theme/icons/icons_and_text.svg';
// BOWLING CENTER DESCRIPTION
import {
  BCDescriptionSchema,
  type BCDescriptionConfig,
} from '@redturtle/qubicaamf-theme/components/Blocks/BowlingCenterDescription/schema';
import descriptionSVG from '@plone/volto/icons/description.svg';
import BCDescriptionBlockView from '@redturtle/qubicaamf-theme/components/Blocks/BowlingCenterDescription/View';
import BCDescriptionBlockEdit from '@redturtle/qubicaamf-theme/components/Blocks/BowlingCenterDescription/Edit';
// BOWLING CENTER HEADER
import BCHeaderBlockView from '@redturtle/qubicaamf-theme/components/Blocks/BowlingCenterHeader/View';
import { BCHeaderBlockEdit } from '@redturtle/qubicaamf-theme/components/Blocks/BowlingCenterHeader';
// PRODUCTS SLIDER
import ProductsSliderSVG from '@redturtle/qubicaamf-theme/icons/products_slider_svg.svg';
import ProductsSliderEdit from '@redturtle/qubicaamf-theme/components/Blocks/ProductsSlider/Edit';
import ProductsSliderView from '@redturtle/qubicaamf-theme/components/Blocks/ProductsSlider/View';
import {
  ProductsSliderSchema,
  type ProductsSliderConfig,
} from '@redturtle/qubicaamf-theme/components/Blocks/ProductsSlider/schema';
// OUR SERVICES
import EditOurServicesBlock from '@redturtle/qubicaamf-theme/components/Blocks/OurServices/Edit';
import ViewOurServicesBlock from '@redturtle/qubicaamf-theme/components/Blocks/OurServices/View';
import {
  OurServicesSchema,
  type OurServicesSchemaConfig,
} from '@redturtle/qubicaamf-theme/components/Blocks/OurServices/schema';
// BOWLING CENTER CAROUSEL
import {
  BowlingCenterCarouselSchema,
  type BowlingCenterCarouselConfig,
} from '@redturtle/qubicaamf-theme/components/Blocks/BowlingCenterCarousel/schema';
import BowlingCenterCarouselSVG from '@redturtle/qubicaamf-theme/icons/bowling_center_carousel.svg';
import BowlingCenterCarouselEdit from '@redturtle/qubicaamf-theme/components/Blocks/BowlingCenterCarousel/Edit';
import BowlingCenterCarouselView from '@redturtle/qubicaamf-theme/components/Blocks/BowlingCenterCarousel/View';

// BLOCK PAGE TITLE WITH MENU
import titleSVG from '@plone/volto/icons/text.svg';
import ViewPageTitleWithMenuBlock from '@redturtle/qubicaamf-theme/components/Blocks/PageTitleWithMenu/View';
import EditPageTitleWithMenuBlock from '@redturtle/qubicaamf-theme/components/Blocks/PageTitleWithMenu/Edit';
import type PageTitleWithMenuConfig from '@redturtle/qubicaamf-theme/components/Blocks/PageTitleWithMenu';

import ViewPageTitleWithParentMenuBlock from '@redturtle/qubicaamf-theme/components/Blocks/PageTitleWithParentMenu/View';
import EditPageTitleWithParentMenuBlock from '@redturtle/qubicaamf-theme/components/Blocks/PageTitleWithParentMenu/Edit';
import type PageTitleWithParentMenuConfig from '@redturtle/qubicaamf-theme/components/Blocks/PageTitleWithParentMenu';

// EXPANDABLE GRID
import gridSVG from '@plone/volto/icons/grid-block.svg';
import ExpandableGridBlockView from '@redturtle/qubicaamf-theme/components/Blocks/ExpandableGrid/View';
import ExpandableGridBlockEdit from '@redturtle/qubicaamf-theme/components/Blocks/ExpandableGrid/Edit';
import {
  ExpandableGridBlockSchema,
  type ExpandableGridConfig,
} from '@redturtle/qubicaamf-theme/components/Blocks/ExpandableGrid/schema';

// BLOG MACROCATEGORIES GALLERY
import { BlogMacroGalleryEdit } from '@redturtle/qubicaamf-theme/components/Blocks/BlogMacroGallery/index';
import BlogMacroGalleryView from '@redturtle/qubicaamf-theme/components/Blocks/BlogMacroGallery/View';
import BlogMacroGallerySchema from '@redturtle/qubicaamf-theme/components/Blocks/BlogMacroGallery/schema';
import type { BlogMacroGalleryConfig } from '@redturtle/qubicaamf-theme/components/Blocks/BlogMacroGallery/schema';

//PRODUCTS TITLE
import EditProductsTitleBlock from '@redturtle/qubicaamf-theme/components/Blocks/Products/Edit';
import ViewProductsTitleBlock from '@redturtle/qubicaamf-theme/components/Blocks/Products/View';
import ProductsMenuSchema from '@redturtle/qubicaamf-theme/components/Blocks/Products/schema';
import { type ProductsMenuConfig } from '@redturtle/qubicaamf-theme/components/Blocks/Products/schema';

declare module '@plone/types' {
  interface BlocksConfigData {
    accordion: AccordionConfig;
    banner: BannerConfig;
    image_gallery: ImageGalleryConfig;
    tabs: TabsConfig;
    cardwithimages: CardWithImagesConfig;
    bowlingcenterdescription: BCDescriptionConfig;
    bowlingcenterheader: BCDescriptionConfig;
    pageintro: PageIntroConfig;
    calltoaction: CallToActionConfig;
    testimonials: TestimonialsConfig;
    iconsandtext: IconsAndTextConfig;
    productsslider: ProductsSliderConfig;
    ourservices: OurServicesSchemaConfig;
    bowlingcentercarousel: BowlingCenterCarouselConfig;
    pagetitlewithmenu: PageTitleWithMenuConfig;
    pagetitlewithparentmenu: PageTitleWithParentMenuConfig;
    expandableGrid: ExpandableGridConfig;
    blogMacrocategoriesGallery: BlogMacroGalleryConfig;
    video_banner: VideoBannerConfig;
    productstitle: ProductsMenuConfig;
  }
}

export type QubicaBlocksConfig = Pick<
  BlocksConfigData,
  | 'accordion'
  | 'banner'
  | 'cardwithimages'
  | 'image_gallery'
  | 'tabs'
  | 'bowlingcenterdescription'
  | 'bowlingcenterheader'
  | 'ourservices'
  | 'pageintro'
  | 'calltoaction'
  | 'testimonials'
  | 'iconsandtext'
  | 'bowlingcentercarousel'
  | 'productsslider'
  | 'pagetitlewithmenu'
  | 'pagetitlewithparentmenu'
  | 'expandableGrid'
  | 'blogMacrocategoriesGallery'
  | 'video_banner'
  | 'productstitle'
>;

const defaultBlocksConfig = {
  restricted: false,
  mostUsed: false,
  security: {
    addPermission: [],
    view: [],
  },
  sidebarTab: 1,
  schema: BlockSettingsSchema,
} as const;

export const qubicaBlocks: QubicaBlocksConfig = {
  pagetitlewithmenu: {
    id: 'pagetitlewithmenu',
    title: 'Page title with menu',
    icon: titleSVG,
    group: 'text',
    view: ViewPageTitleWithMenuBlock,
    edit: EditPageTitleWithMenuBlock,
    schema: BlockSettingsSchema,
    restricted: ({ properties, block, contentType }) =>
      contentType !== 'Document' ||
      !!properties.blocks_layout?.items?.find(
        (uid) => properties.blocks?.[uid]?.['@type'] === block.id,
      ),
    mostUsed: false,
    blockHasOwnFocusManagement: true,
    sidebarTab: 0,
  },
  pagetitlewithparentmenu: {
    id: 'pagetitlewithparentmenu',
    title: 'Page title with parent menu',
    icon: titleSVG,
    group: 'text',
    view: ViewPageTitleWithParentMenuBlock,
    edit: EditPageTitleWithParentMenuBlock,
    schema: BlockSettingsSchema,
    restricted: ({ properties, block, contentType }) =>
      contentType !== 'Document' ||
      !!properties.blocks_layout?.items?.find(
        (uid) => properties.blocks?.[uid]?.['@type'] === block.id,
      ),
    mostUsed: false,
    blockHasOwnFocusManagement: true,
    sidebarTab: 0,
  },
  pageintro: {
    ...defaultBlocksConfig,
    id: 'pageintro',
    title: 'Page intro',
    icon: pageintroSVG,
    group: 'text',
    view: PageIntroView,
    edit: PageIntroEdit,
    blockHasOwnFocusManagement: true,
    blockSchema: PageIntroSchema,
  },
  calltoaction: {
    ...defaultBlocksConfig,
    id: 'calltoaction',
    title: 'Call To Action',
    icon: calltoactionSVG,
    group: 'text',
    view: CallToActionView,
    edit: CallToActionEdit,
    blockHasOwnFocusManagement: true,
    blockSchema: CallToActionSchema,
  },
  testimonials: {
    ...defaultBlocksConfig,
    id: 'testimonials',
    title: 'Testimonials',
    icon: CardWithImagesSVG,
    group: 'text',
    view: TestimonialsView,
    edit: TestimonialsEdit,
    blockHasOwnFocusManagement: true,
    blockSchema: TestimonialsSchema,
  },
  iconsandtext: {
    ...defaultBlocksConfig,
    id: 'iconsandtext',
    title: 'Icon & Text',
    icon: iconsAndTextSVG,
    group: 'text',
    mostUsed: true,
    view: IconsAndTextView,
    edit: IconsAndTextEdit,
    blockHasOwnFocusManagement: true,
    blockSchema: IconsAndTextSchema,
  },
  banner: {
    id: 'banner',
    title: 'Banner',
    icon: BannerSVG,
    group: 'media',
    mostUsed: true,
    view: BannerView,
    edit: BannerEdit,
    blockSchema: BannerSchema,
    ...defaultBlocksConfig,
  },
  image_gallery: {
    id: 'image_gallery',
    title: 'Image Gallery',
    icon: ImageGalleryIcon,
    group: 'media',
    mostUsed: true,
    view: ImageGalleryView,
    edit: ImageGalleryEdit,
    blockSchema: ImageGallerySchema,
    ...defaultBlocksConfig,
  },
  tabs: {
    id: 'tabs',
    title: 'Tabs',
    icon: TabsIconSVG,
    group: 'common',
    mostUsed: true,
    view: TabsView,
    edit: TabsEdit,
    blockSchema: TabsSchema,
    allowedBlocks: [
      'image',
      'listing',
      'slate',
      'teaser',
      'calltoaction',
      'cardwithimages',
      'gridBlock',
      'pageintro',
      'expandableGrid',
    ],
    ...defaultBlocksConfig,
  },
  accordion: {
    id: 'accordion',
    title: 'Accordion',
    icon: accordionSVG,
    group: 'common',
    view: AccordionView,
    edit: AccordionEdit,
    blockSchema: AccordionSchema,
    blockHasOwnFocusManagement: true,
    ...defaultBlocksConfig,
  },
  cardwithimages: {
    ...defaultBlocksConfig,
    id: 'cardwithimages',
    title: 'Card with Image',
    icon: CardWithImagesSVG,
    group: 'text',
    view: CardWithImagesView,
    edit: CardWithImagesEdit,
    mostUsed: true,
    blockHasOwnFocusManagement: true,
    blockSchema: CardWithImagesSchema,
  },
  bowlingcenterdescription: {
    ...defaultBlocksConfig,
    blockSchema: BCDescriptionSchema,
    id: 'bowlingcenterdescription',
    title: 'Bowling Center Description',
    icon: descriptionSVG,
    group: 'text',
    view: BCDescriptionBlockView,
    edit: BCDescriptionBlockEdit,
    blockHasOwnFocusManagement: true,
    restricted: ({ properties, block, contentType }) =>
      contentType !== 'PortfolioBowlingCenter' ||
      !!properties.blocks_layout?.items?.find(
        (uid) => properties.blocks?.[uid]?.['@type'] === block.id,
      ),
  },
  bowlingcenterheader: {
    ...defaultBlocksConfig,
    id: 'bowlingcenterheader',
    title: 'Bowling Center Header',
    icon: descriptionSVG,
    group: 'text',
    view: BCHeaderBlockView,
    edit: BCHeaderBlockEdit,
    restricted: ({ properties, block, contentType }) =>
      contentType !== 'PortfolioBowlingCenter' ||
      !!properties.blocks_layout?.items?.find(
        (uid) => properties.blocks?.[uid]?.['@type'] === block.id,
      ),
    mostUsed: false,
    blockHasOwnFocusManagement: true,
    sidebarTab: 1,
    requiredBlocks: 1,
    blockSchema: undefined,
  },
  bowlingcentercarousel: {
    ...defaultBlocksConfig,
    id: 'bowlingcentercarousel',
    title: 'Bowling Center Carousel',
    icon: BowlingCenterCarouselSVG,
    group: 'media',
    view: BowlingCenterCarouselView,
    edit: BowlingCenterCarouselEdit,
    blockSchema: BowlingCenterCarouselSchema,
    restricted: ({ properties }) => {
      if (properties['@type'] !== 'PortfolioBowlingCenter') {
        return true;
      } else return false;
    },
  },
  productsslider: {
    ...defaultBlocksConfig,
    id: 'productsslider',
    title: 'Products Slider',
    icon: ProductsSliderSVG,
    group: 'media',
    view: ProductsSliderView,
    edit: ProductsSliderEdit,
    blockSchema: ProductsSliderSchema,
  },
  ourservices: {
    ...defaultBlocksConfig,
    id: 'ourservices',
    title: 'Our Services',
    icon: descriptionSVG,
    group: 'text',
    view: ViewOurServicesBlock,
    edit: EditOurServicesBlock,
    blockSchema: OurServicesSchema,
    mostUsed: true,
    blockHasOwnFocusManagement: true,
    sidebarTab: 1,
  },
  expandableGrid: {
    ...defaultBlocksConfig,
    id: 'expandableGrid',
    title: 'Expandable Cards',
    icon: gridSVG,
    group: 'text',
    view: ExpandableGridBlockView,
    edit: ExpandableGridBlockEdit,
    blockSchema: ExpandableGridBlockSchema,
    allowedBlocks: ['cardwithimages'],
  },
  blogMacrocategoriesGallery: {
    ...defaultBlocksConfig,
    id: 'blogMacrocategoriesGallery',
    title: 'Blog Macro Gallery',
    icon: ImageGalleryIcon,
    group: 'media',
    edit: BlogMacroGalleryEdit,
    view: BlogMacroGalleryView,
    blockSchema: BlogMacroGallerySchema,
    blockHasOwnFocusManagement: true,
  },
  video_banner: {
    ...defaultBlocksConfig,
    id: 'video_banner',
    title: 'Video Banner',
    icon: VideoBannerSVG,
    group: 'media',
    edit: VideoBannerEdit,
    view: VideoBannerView,
    blockSchema: VideoBannerSchema,
  },
  productstitle: {
    id: 'productstitle',
    title: 'Products Title',
    icon: titleSVG,
    group: 'text',
    view: ViewProductsTitleBlock,
    edit: EditProductsTitleBlock,
    blockSchema: ProductsMenuSchema,
    restricted: ({ properties, block, contentType }) =>
      contentType !== 'Product' ||
      !!properties.blocks_layout?.items?.find(
        (uid) => properties.blocks?.[uid]?.['@type'] === block.id,
      ),
    mostUsed: false,
    blockHasOwnFocusManagement: true,
    sidebarTab: 1,
  },
} as const;
